import axios from '../../axios/axios';

const ExcursionService = {

  getAllExcursions: (pageNumber = 0, pageSize = 5, sortField = 'name', sortOrder = 'asc', search = '') => {
    let url = `/excursions?page=${pageNumber}&size=${pageSize}&sortBy=${sortField}&sortDirection=${sortOrder}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    return axios.get(url);
  },

  getOngoingExcursions: () => {
    return axios.get(`/excursions/getAllOngoing`)
  },

  getExcursionById: (id) => {
    return axios.get(`/excursions/${id}`)
  },

  addExcursion: (name, placeTo, dateFrom, dateTo, price, discount, totalSeats, bookedSeats) =>{
    const newExcursion = {
      name: name,
      placeTo: placeTo,
      dateFrom: dateFrom,
      dateTo: dateTo,
      price: price,
      discount: discount,
      totalSeats: totalSeats,
      bookedSeats: bookedSeats
    }
    return axios.post("/excursions/add", newExcursion, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  updateExcursion: (id, name, placeTo, dateFrom, dateTo, price, discount, totalSeats, bookedSeats) =>{
    const updatedExcursion = {
      name: name,
      placeTo: placeTo,
      dateFrom: dateFrom,
      dateTo: dateTo,
      price: price,
      discount: discount,
      totalSeats: totalSeats,
      bookedSeats: bookedSeats
    }
    return axios.post(`/excursions/update/${id}`, updatedExcursion, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  deleteExcursion: (id) =>{
    return axios.delete(`excursions/delete/${id}`)
  },

  exportExcursions: () => {
    return axios.get(`excursions/export`, {
      responseType: 'blob',
    })
  },

}
export default ExcursionService